import { sendRequest } from '../../config';

export interface EnviarPlanDeTratamientosParams {
    /** parametros obligatorios */
    cpais: string;
    cusuario: string;
    ccategoria: string;
    nlocaliza: string;
}

export interface dataEnviarPlanDeTratamientos {
    description?: string;
}

export const enviarPlanDeTratamientos = async (params: EnviarPlanDeTratamientosParams): Promise<dataEnviarPlanDeTratamientos> => {
    const ENDPOINT = 'wstratamientos/enviarPlanDeTratamientos2';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};